import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { IPreviewContext } from '~/types/builder.types';
import { useCXRootStore } from '~/components/ClientExperience/stores/cx-root-store.provider';

export const INITAL_PREVIEW_CONTEXT: IPreviewContext = {
    forceMobile: false,
    isExpiryPreview: false,
    expiryPreviewMessage: null,
    isPreviewContractSigned: false,
    isPreviewServiceSelected: false
};

export default function useSetPreviewContext() {
    const {
        flowViewUiStore: { setPreviewContext, selectedFlow }
    } = useCXRootStore();

    const location = useLocation();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const previewCtx: Partial<IPreviewContext> = {
            isExpiryPreview: queryParams.get('expiryMode') === 'true',
            expiryPreviewMessage: queryParams.get('expirationMessage'),
            isPreviewContractSigned: !isEmpty(selectedFlow?.firstClient)
        };

        setPreviewContext(previewCtx);

        return () => {
            setPreviewContext(INITAL_PREVIEW_CONTEXT);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
